module.exports = __webpack_public_path__ + "static/media/orgl.4ae212c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/orgl.jpg
// module id = 743
// module chunks = 0